<div class="side-menu-container" [ngClass]="{ 'collapsed': authenticationService.isEmbedded || !(menuDataService.toggleMenuBar | async) }">
  <!-- tabMenu -->
  <div class="menu-tab-sticky">
    <p-tabMenu
      [model]="menuTabs"
      [(activeItem)]="activeTabItem"
      (activeItemChange)="onTabChange($event)"
      styleClass="menu-tabmenu"
    ></p-tabMenu>
  </div>

  <!-- scrollable menu -->
  <div class="menu-scroll-body">
    <p-panelMenu
      [model]="showItems"
      [style]="{ width: '100%' }"
      [multiple]="true"
    ></p-panelMenu>
  </div>
</div>
